import { render, staticRenderFns } from "./LeadLeadForms.vue?vue&type=template&id=c2ac0228&"
import script from "./LeadLeadForms.vue?vue&type=script&lang=js&"
export * from "./LeadLeadForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports